<template>
  <div class="barometer">
    <el-dialog :title="obtName + '(晴雨表)'" :visible.sync="params.flag" v-dialogDrag :modal="false"
      :close-on-click-modal="false" :lock-scroll="false" :modal-append-to-body=false ref="yuqingRef"
      :before-close="() => params.flag && this.$parent.toggleProductView(this.params.productInfo.code)">
      <div class="options">
        <div class="title">施工晴雨表</div>
        <div class="legend">
          <div class="item">
            <i style="background: #80d565"></i><span>晴</span>
          </div>
          <!-- <div class="item">
            <i style="background: #ffa956"></i><span>风</span>
          </div>
          <div class="item">
            <i style="background: #cfcfcf"></i><span>阴</span>
          </div> -->
          <div class="item">
            <i style="background: #7aaeff"></i><span>雨</span>
          </div>
        </div>
      </div>
      <div class="options">
        <div class="select">
          <el-checkbox-group v-model="checkElements" @change="hanldChange">
            <el-checkbox v-for="item in elements" :key="item" :label="item"></el-checkbox>
          </el-checkbox-group>
        </div>
        <button class="export" @click="exportExcel('晴雨表')">导出</button>
      </div>
      <div class="table" ref="tabel" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <table width="100%" cellspacing="0" cellpadding="0" class="table-head" v-if="(barData.length > 0)">
          <thead>
            <tr>
              <th class="month">月</th>
              <th class="element">要素</th>
              <th v-for="index in 31" :key="index">{{ index }}</th>
            </tr>
          </thead>
        </table>
        <div class="data-wrap">
          <el-scrollbar>
            <table width="100%" cellspacing="0" cellpadding="0" class="table-content">
              <tbody>
                <tr v-for="i in 12 * checkElements.length" :key="i">
                  <td :rowspan="checkElements.length" v-if="i % checkElements.length === 1" class="month hasBottom">
                    {{ Math.ceil(i / checkElements.length) }}月
                  </td>
                  <td v-else-if="checkElements.length === 1">
                    {{ Math.ceil(i / checkElements.length) }}月
                  </td>
                  <td :class="{ element: true, hasBottom: i % checkElements.length == 0 }">
                    {{ checkElements[(i - 1) % checkElements.length] }}
                    <span v-show="['上午天气', '下午天气'].includes(checkElements[(i - 1) % checkElements.length])">
                      <span class="time-icon">
                        <img src="@/assets/images/解释.png" alt="">
                        <div class="time-tip">{{ checkElements[(i - 1) % checkElements.length] === '上午天气' ?
                          '上午时间：9:00-12:00'
                          : '下午时间：14:00-18:00' }}</div>
                      </span>
                    </span>
                  </td>
                  <td v-for="index in 31" :key="index" :class="{ hasBottom: i % checkElements.length == 0 }">
                    <div class="no-export" v-show="true">
                      <span v-if="barData[i - 1] && barData[i - 1][index - 1] === '晴'" class='qing'></span>
                      <span v-else-if="barData[i - 1] && barData[i - 1][index - 1] === '雨'" class='yu'></span>
                      <span v-else>{{ barData[i - 1] && barData[i - 1][index - 1] }}</span>
                    </div>
                    <div class="export" v-show="false">
                      <span>{{ barData[i - 1] && barData[i - 1][index - 1] }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </el-scrollbar>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import { apiData } from '@/api'
import { mapState } from 'vuex'
export default {
  props: ['params'],
  data() {
    return {
      checkElements: ['上午天气', '下午天气', '最高温度℃'],
      elements: ['上午天气', '下午天气', '最高温度℃', '最低温度℃', '平均风m/s', '降雨量mm'],
      totalData: {},
      barData: [],
      loading: true,
      obtName: ''

    }
  },
  watch: {
    activeCountyId: {
      handler(id) {
        this.loading = true
        const item = this.objsList.find(item => item.id === id)
        if (item) {
          this.selectQyTable(item.id)
          this.obtName = item.name
        }
      },
      immediate: true
    },
    'params.flag': {
      handler(flag) {
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId'])
  },
  methods: {
    hanldChange() {
      this.loading = true
      this.filterDate()
    },
    async selectQyTable(id) {
      const year = new Date().getFullYear()
      const result = await apiData.selectQyTable(id, year)
      if (result.status === 200) {
        this.totalData = result.data
        this.filterDate()
      }
    },
    filterDate() {
      this.barData = []
      const elemnts = [{ name: '上午天气', value: 'sw' }, { name: '下午天气', value: 'xw' }, { name: '最高温度℃', value: 'maxt' }, { name: '最低温度℃', value: 'mint' }, { name: '平均风m/s', value: 'avgw' }, { name: '降雨量mm', value: 'dayr' }]
      for (let index = 0; index < 12; index++) {
        const monthKey = index + 1
        this.checkElements.forEach(elementItem => {
          const field = elemnts.find(element => element.name === elementItem).value
          this.barData.push(this.totalData[monthKey][field])
        })
      }
      this.loading = false
    },
    exportExcel(excelName) {
      try {
        const $e = this.$refs.tabel
        const $table = $e
        const wb = XLSX.utils.table_to_book($table, { raw: true })
        const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          '晴雨表.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.error(e)
      }
    },
    // 设置弹出框的zIndex
    setZindex() {
      this.$nextTick(() => {
        const el = this.$refs.yuqingRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }
}
</script>
<style lang="less" scoped>
.barometer {
  display: flex;
  flex-direction: column;
  pointer-events: none;

  .options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.8rem;

    .title {
      font-size: 1.13rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #FFF;
    }

    .legend {
      display: flex;

      .item {
        color: #FFF;
        font-size: 0.88rem;
        display: flex;
        align-items: center;
        margin-right: 10px;

        i {
          display: inline-block;
          width: 0.88rem;
          height: 0.88rem;
          border-radius: 0.88rem;
          margin-right: 5px;
        }
      }
    }

    .select {
      /deep/.el-checkbox-group {
        .el-checkbox {
          font-size: 0.88rem;

          .el-checkbox__label {
            font-size: 0.88rem;
            color: #FFF;
          }
        }
      }
    }

    .export {
      border: 0;
      background: transparent url("../assets/images/打印.png") left center no-repeat;
      background-size: 1.13rem 1.11rem;
      font-size: 0.88rem;
      padding-left: 1.5rem;
      color: #FFF;
      cursor: pointer;
    }
  }

  .table {
    flex: 1;
    display: flex;
    flex-direction: column;

    .data-wrap {
      flex: 1;
      position: relative;

      /deep/.el-scrollbar {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;

        .el-scrollbar__wrap {
          overflow-x: hidden;
        }
      }
    }

    table {
      border-right: 1px solid #316EA3;

      tr {
        border-bottom: 0.1vw solid #316EA3;

        th,
        td {
          border-left: 1px solid #316EA3;
          border-top: 1px solid #316EA3;
          color: #FFF;
          width: 2.13rem;
          text-align: center;
          font-size: 0.88rem;
          font-weight: normal;
        }

        th {
          height: 3.25rem;
        }

        td {
          height: 2.19rem;
        }

        .month {
          width: 3.69rem;
        }

        .element {
          width: 5.75rem;
        }

        .hasBottom {
          border-bottom: 0.1vw solid #316EA3;
        }

        .time-icon {
          margin-left: 0.16vw;
          position: relative;

          img {
            width: 0.68vw;
          }

          &:hover {
            cursor: pointer;

            .time-tip {
              background: rgba(5, 44, 77, 1);
              display: block;
            }
          }
        }

        .time-tip {
          display: inline-block;
          display: none;
          position: absolute;
          top: 120%;
          left: -1.04vw;
          z-index: 4;
          width: 150px;
          padding: 0.16vw 0.26vw;
          font-size: 0.73vw;
          color: #FFF;
          background: #FFFFFF;
          box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.15);
        }

        .qing {
          display: inline-block;
          width: 0.88rem;
          height: 0.88rem;
          border-radius: 0.88rem;
          margin-right: 0.26vw;
          background: rgb(128, 213, 101);
        }

        .yu {
          display: inline-block;
          width: 0.88rem;
          height: 0.88rem;
          border-radius: 0.88rem;
          margin-right: 0.26vw;
          background: rgb(122, 174, 255);
        }
      }
    }

    .table-head {
      background: #3C7CB8;
    }

    .table-content {
      border-bottom: 1px solid #316EA3;

      tbody {
        tr {
          border: 1px solid #316EA3;
        }
      }
    }
  }

  /deep/.el-dialog__wrapper {
    .el-dialog {
      pointer-events: auto;
      width: 85.81rem;
      margin-top: 5vh !important;
      height: 84vh;
    }
  }
}

/deep/ .el-checkbox__inner {
  background: #2B3751;
}

/deep/ .is-checked .el-checkbox__inner {
  background: #6FBEFF;
}
</style>
